module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('swiper', {
    ref: "mySwiper",
    staticClass: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('img', {
    attrs: {
      "src": require("../assets/img/swiper01.jpg"),
      "width": "100%/"
    }
  })]), _vm._v(" "), _c('swiper-slide', [_c('img', {
    attrs: {
      "src": require("../assets/img/swiper02.jpg"),
      "width": "100%/"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    slot: "pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-scrollbar",
    slot: "scrollbar"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-86d31906","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/Swiper.vue
// module id = 193
// module chunks = 1